import { useCallback } from 'react';
import { createPath, useLocation, useNavigate } from 'react-router-dom';
import { useStateInRef } from 'seagull';
import { useOverlayContext } from '~/contexts';
import { useIoContext } from '~/providers/IoContext';
import { isRouteChunkReady, preloadRouteChunk } from '~/utils/routeConfigs';
const ROUTE_PRELOAD_LOADER = 'route-preload';
export function usePreloadNavigate() {
    const navigate = useNavigate();
    const { startLoader, stopLoader } = useOverlayContext();
    const { browser } = useIoContext();
    const getLocation = useStateInRef(useLocation());
    return useCallback((path)=>{
        browser.afterNextPaint(()=>{
            const navigateWithSamePathReplace = ()=>navigate(path, {
                    replace: createPath(getLocation()) === path
                });
            if (isRouteChunkReady(path)) {
                navigateWithSamePathReplace();
                return;
            }
            startLoader(ROUTE_PRELOAD_LOADER);
            void preloadRouteChunk(path).finally(()=>{
                stopLoader(ROUTE_PRELOAD_LOADER);
                navigateWithSamePathReplace();
            });
        });
    }, []);
}
